/* eslint-disable */
import { useGlobals } from '~hooks'
import { AmplitudeData } from './interfaces'

const useAmplitude = () => {
  const { amplitude } = useGlobals()

  const sendAmplitude = (tag: string, data?: AmplitudeData) => {
    amplitude().logEvent(tag, data)
  }

  return {
    sendAmplitude,
  }
}

export default useAmplitude
